import { PriorityInterface } from "../../models/TicketModule/Priority";
import client from "../client";

class PriorityService {
  async GetAll(page: number, pageSize: number) {
    try {
      let url = `/api/Priorities`;

      if (page > 0 && pageSize > 0) {
        url += `?page=${page}&pageSize=${pageSize}`;
      }
      const { data } = await client.get<PriorityInterface[]>(url);
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async GetById(id: string) {
    try {
      let url = `/api/Priorities/getbyid/${id}`;

      const { data } = await client.get<PriorityInterface>(url);

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async Save(priority: PriorityInterface) {
    try {
      let url = `/api/Priorities`;

      const { data } = await client.post<PriorityInterface>(url, priority);

      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async Update(id: string, priority: PriorityInterface) {
    try {
      let url = `/api/Priorities/update/${id}`;

      const { data } = await client.post<PriorityInterface>(url, priority);

      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
  async Remove(id: string) {
    try {
      let url = `api/Priorities/remove/${id}`;
      await client.post<PriorityInterface>(url, { url: "" });
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
}

export default new PriorityService();
